export default __webpack_public_path__ + "static/media/banner1.552c89c2.png";